import axios        from 'axios';
import { Config }   from './configActions';

export const FETCH_ALL_EQUIPES_ALUNOS              = 'FETCH_ALL_EQUIPES_ALUNOS';
export const FETCH_ALL_TURMA_DISCIPLINA            = 'FETCH_ALL_TURMA_DISCIPLINA';
export const FETCH_ALL_EQUIPE_TURMA                = 'FETCH_ALL_EQUIPE_TURMA';
export const FETCH_ALL_EQUIPE_POSTS                = 'FETCH_ALL_EQUIPE_POSTS';
export const FETCH_ALL_ALUNOS_EQUIPE               = 'FETCH_ALL_ALUNOS_EQUIPE';
export const FETCH_ALL_ALUNOS_ADICIONAR_EQUIPE     = 'FETCH_ALL_ALUNOS_ADICIONAR_EQUIPE';
export const FETCH_ALL_COMENTARIOS_POSTS_EQUIPE    = 'FETCH_ALL_COMENTARIOS_POSTS_EQUIPE';
export const FETH_COMENTATIO_POST_EQUIPE           = 'FETH_COMENTATIO_POST_EQUIPE';
export const FETH_ALL_PROFESSOR_EQUIPE             = 'FETH_ALL_PROFESSOR_EQUIPE';
export const FETH_ALL_PROFESSOR_TURMA_DISCIPLLINA  = 'FETH_ALL_PROFESSOR_TURMA_DISCIPLLINA';
export const FETH_ALL_EQUIPES_ATIVAS_INATIVAS_PROFESSOR        = 'FETH_ALL_EQUIPES_ATIVAS_INATIVAS_PROFESSOR';
export const ADD_POST_EQUIPE                       = 'ADD_POST_EQUIPE';
export const ADD_LIKE_POST_EQUIPE                  = 'ADD_LIKE_POST_EQUIPE';
export const ADD_POST_COMENTARIO_EQUIPE            = 'ADD_POST_COMENTARIO_EQUIPE';
export const REMOVER_POST_EQUIPE                   = 'REMOVER_POST_EQUIPE';
export const REMOVER_COMENTARIO_POST_EQUIPE        = 'REMOVER_COMENTARIO_POST_EQUIPE';
export const REMOVER_EQUIPE                        = 'REMOVER_EQUIPE';
export const REMOVER_ALUNO_EQUIPE                  = 'REMOVER_ALUNO_EQUIPE';
export const FETCH_ALL_DISCIPLINA_PROFESSOR        = 'FETCH_ALL_DISCIPLINA_PROFESSOR';
export const ADD_EQUIPE                            = 'ADD_EQUIPE';
export const UPDATE_EQUIPE                         = 'UPDATE_EQUIPE';
export const DESATIVAR_EQUIPES                     = 'DESATIVAR_EQUIPES';



var Authorization = {'Authorization': 'Bearer '+localStorage.getItem("jwtToken")}
Config();	

export function Dados_tur_dis(tur_id,dis_id){

   
   return{
        type    : FETCH_ALL_TURMA_DISCIPLINA,
        payload : {tur_id:tur_id,dis_id:dis_id}
    };

}

export function GetEquipesAlunos(usu_id){


    const request = axios.get(`/api/equipes/aluno/lista/${usu_id}`,Authorization);
    return{
        type    : FETCH_ALL_EQUIPES_ALUNOS,
        payload : request
    };

}

export function GruposTurmas(tur_id){

   
   const request = axios.get(`/api/equipes/listar/turma/${tur_id}`,Authorization);
   return{
        type    : FETCH_ALL_EQUIPE_TURMA,
        payload : request
    };

}

export function GetRegistroPostEquipe(use_id,que_id) {

        const id_equipe = (que_id ? '/'+que_id : "");
        const request = axios.get(`/api/equipes/post/listar/${use_id}${id_equipe}`,Authorization);
    
        return{
            type    : FETCH_ALL_EQUIPE_POSTS,
            payload : request
        };
       
}

export function GetGruposAlunos(que_id) {
			
    const request = axios.get(`/api/equipes/listar/alunos/${que_id}`,Authorization);
    return{
        type    : FETCH_ALL_ALUNOS_EQUIPE,
        payload : request
    };

}

export function GetDisciplinaProfessorTurma(id_professor,id_turma) {
			
    const request = axios.get(`/api/disciplinas/professor/turma/listar/${id_professor}/${id_turma}`,Authorization);
    return{
        type    : FETCH_ALL_DISCIPLINA_PROFESSOR,
        payload : request
    };

}

export function GetComentariosPosts(equ_id_post) {
	
    const request =  axios.get(`/api/equipes/comentario/listar/${equ_id_post}`,Authorization);
    return{
        type    : FETCH_ALL_COMENTARIOS_POSTS_EQUIPE,
        payload : request
    };
}

export function GetAdicionarAlunoEquipe(tur_id,dis_id) {
    const request =  axios.get(`/api/equipes/listar/alunos/semequipe/${tur_id}/${dis_id}`,Authorization);
    return{
        type    : FETCH_ALL_ALUNOS_ADICIONAR_EQUIPE,
        payload : request
    };
}

export function GetRemoverPostEquipe(use_id,id_post) {
    
    axios.get(`/api/equipes/post/apagar/${id_post}/${use_id}`,Authorization);
    return {
        type    : REMOVER_POST_EQUIPE,
        payload : id_post
    }
}

export function GetComentariosPost(equ_id_post) {
	
    const request =  axios.get(`/api/equipes/comentario/listar/${equ_id_post}`,Authorization);
    return {
        type    : FETH_COMENTATIO_POST_EQUIPE,
        payload : request
    }

}

export function GetListGrupo(use_id) {
    
     const request = axios.get(`/api/turmas/listar/professor/${use_id}`,Authorization);
     return {
         type    : FETH_ALL_PROFESSOR_EQUIPE,
         payload : request
     }

}

export function GetListProfessorTurmaDisciplina(use_id) {
    
    const request = axios.get(`/api/disciplinas/professor/listar/${use_id}`,Authorization);
    return {
        type    : FETH_ALL_PROFESSOR_TURMA_DISCIPLLINA,
        payload : request
    }

}

export function GetListProfessorDisciplina(dis_id,tur_id) {
    
    const request = axios.get(`/api/equipes/professor/disciplina/${dis_id}/${tur_id}`,Authorization);
    return {
        type    : FETH_ALL_EQUIPES_ATIVAS_INATIVAS_PROFESSOR,
        payload : request
    }
}

export function GetGruposTurmas(tur_id) {
    
	return dispatch => {

         return axios.get(`/api/equipes/listar/turma/${tur_id}`,Authorization);
    }

}

export function GetRemoverComentarioEquipe(use_id,elem) {
	
	 const request = axios.get(`/api/equipes/comentario/apagar/${elem.equ_com_pos_id}/${use_id}`,Authorization);
	 const retorno = axios.all([elem,request]);
     return {
               type    : REMOVER_COMENTARIO_POST_EQUIPE,
               payload : retorno
            }
}

export function GetQtdCommentPost(pos_id) {
	
	return dispatch => {

         return axios.get(`/api/equipes/comentario/qtd/${pos_id}`,Authorization);
    }

}

export function GetTipoMidiaPost(elem){

    return dispatch => {     

                const obj = {}
                switch (elem.equ_pos_tipo) {

                    case 2:
                           obj.retorno = `<p><img class="img-responsive" src=${elem.equ_pos_midia} /></p>`;   
                    
                    break;       
                    case 3:
                            obj.retorno =  `
                                                <div class="embed-responsive embed-responsive-4by3">
                                                        <iframe 
                                                                width="854" 
                                                                height="480" 
                                                                class="embed-responsive-item" 
                                                                src="${`https://www.youtube.com/embed/${elem.equ_pos_midia}`}" 
                                                                frameborder="0" 
                                                                allowfullscreen>
                                                        </iframe>
                                                </div>
                                            `;   
                                
                   break;

                    default:
                        obj.retorno =  null;
                   break;
                }
                return obj.retorno;
         }
   
}

export function SetComentarioPost(dados,comentario){

    const request = axios.post('/api/equipes/comentario/cadastrar',{

                equ_com_pos_cod_equipe_post : dados.equ_pos_id,
                equ_com_pos_cod_usuario     : dados.use_id,
                equ_com_pos_comentario      : comentario,

            },Authorization);

    const requestQtd =  axios.get(`/api/equipes/comentario/qtd/${dados.equ_pos_id}`,Authorization);
    const retorno    = axios.all([request,requestQtd]);
            
    return {
            type    : ADD_POST_COMENTARIO_EQUIPE,
            payload : retorno
    }  
    
}

export function SendPublic(dados,file){

          if (file !==null) {
                const formData = new FormData();
                formData.append('equ_pos_midia', file[0]);
                formData.append('equ_pos_cod_equipe', dados.equ_pos_cod_equipe);
                formData.append('equ_pos_cod_usuario', dados.equ_pos_cod_usuario);
                formData.append('equ_pos_tipo', dados.equ_pos_tipo);
                formData.append('equ_pos_post', dados.equ_pos_post);
                const request =  axios.post('/api/equipes/post/cadastrar', formData,Authorization);

                return{
                    type    : ADD_POST_EQUIPE,
                    payload : request
                };
              
          } else {

                const request = axios.post("/api/equipes/post/cadastrar", {
                            equ_pos_cod_equipe  : dados.equ_pos_cod_equipe,
                            equ_pos_cod_usuario : dados.equ_pos_cod_usuario,
                            equ_pos_tipo        : dados.equ_pos_tipo,
                            equ_pos_midia       : dados.equ_pos_midia,
                            equ_pos_post        : dados.equ_pos_post
                },Authorization);

                return{
                    type    : ADD_POST_EQUIPE,
                    payload : request
                };
          }
                
     

}

export function SetLikePostUser(equ_post_id,use_id){

      const request = axios.get(`/api/equipes/like/registrar/${equ_post_id}/${use_id}`,Authorization);
      return {
            type    : ADD_LIKE_POST_EQUIPE,
            payload : request
      }
    
}

export function removerGruposTurmas(equ_id) {
	
  axios.get(`/api/equipes/apagar/${equ_id}`,Authorization);
  return{
        type    : REMOVER_EQUIPE,
        payload : equ_id
    };  
}

export function RemoverAlunoEquipe(alu_id,equ_id,use_id) {
	
     axios.get(`/api/equipes/remover/aluno/${alu_id}/${equ_id}/${use_id}`,Authorization);
     return{
        type    : REMOVER_ALUNO_EQUIPE,
        payload : alu_id
    };  

}

export function SetCadastroGrupo(dados,equ_rand) {
	
        const acao = (dados.equ_id === 0
                        ? {
                                        method: axios.post,
                                        rota: "/api/equipes/cadastrar"
                        }
                        : {
                                        method: axios.post,
                                        rota: "/api/equipes/atualizar"
                        });

            const rota = acao.rota;
            const request =  acao.method(rota, {

            //equ_nome           : equ_nome,
            equ_nome           : dados.listNomesEquipes,
            equ_cod_professor  : dados.use_id,
            equ_cod_disciplina : dados.dis_id,
            equ_cod_turma      : dados.tur_id,
            equ_id             : dados.equ_id,
            equ_flag_rand      : equ_rand

        },Authorization);

        return{
            type    : (dados.equ_id === 0 ? ADD_EQUIPE : UPDATE_EQUIPE),
            payload : request
        }; 
  

}

export function SetAdicionarAlunoEquipe(dados) {
	
	return dispatch => {

         
                return axios.post("/api/equipes/adiconar/alunos", {

                        alu_equ_cod_aluno     : dados.alu_equ_cod_aluno,
                        alu_equ_cod_equipe    : dados.alu_equ_cod_equipe,
                        alu_equ_cod_professor : dados.alu_equ_cod_professor

                    },Authorization);
    }

}

export function SetValidUrlYoutube(url){
    
    	return dispatch => {
                var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\/)|(\?v=|\&v=))([^#\&\?]*).*/;
                var match = url.match(regExp);
                if (match && match[8].length===11){
                        return 1;
                }else{
                    return 0;
                }
        }

}

export function SetUploadFiles(equ_pos_id,file) {

				return dispatch => {
                 
                    const formData = new FormData();
                    formData.append('equ_pos_midia', file[0]);
                    formData.append('equ_pos_id', equ_pos_id);
                    return axios.post('/api/equipes/post/upload', formData,Authorization);
							
						
				}

}

export function ClearUrl(url){

    return dispatch => {
            var re = url.replace('https://www.youtube.com/watch?v=','').replace('https://youtu.be/','');

            var url1 = re.split("?").length;
            var url2 = re.split("&").length;

                
            if(url1>1){
                    
                var re1 = re.split("?");		
                return re1[0];

            }


            if(url2>1){
                    
                var re2 = re.split("&");		
                return re2[0];

            }


            if(url1 === 1 || url2 === 1){
                    
                    
                return re;

            }else{

                return "";
            }	

        }

}

export function DesativarEquipes(dis_id) {


const lista = axios.get(`/api/equipes/desativar/${dis_id}`, Authorization);

return {
    type: DESATIVAR_EQUIPES,
    payload: lista
};



}


// WEBPACK FOOTER //
// ./src/actions/grupoAction.js